import React from 'react';

import Image from '../../Commons/Image/Image';
import ZAMORA from '../../../assets/swiss-medical-center/centro_lomas.jpg';

import styles from './SwissMedicalZamora.module.scss';

const SwissMedicalZamora = () => {
  return (
    <div className={styles.swiss_medical_zamora}>
      <h3>Swiss Medical Center Lomas de Zamora</h3>
      <p>
        <strong className={styles.swiss_medical_zamora__redText}>Dirección:</strong> Vicente Oliden
        141/151, Lomas de Zamora
      </p>
      <p>
        <strong className={styles.swiss_medical_zamora__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={ZAMORA}
        alt='Sede Lomas de Xamora'
        title='Swiss Medical Center Lomas de Zamora'
        classes={styles.swiss_medical_zamora__image}
      />
      <div className={styles.swiss_medical_zamora__listContainer}>
        <div>
          <p>
            <strong className={styles.swiss_medical_zamora__redText}>Especialidades medicas</strong>
          </p>
          <ul>
            <li>Cardiología</li>
            <li>Cirugía general</li>
            <li>Clínica médica</li>
            <li>Dermatología</li>
            <li>Enfermeria</li>
            <li>Obstetricia</li>
            <li>Oftalmología</li>
            <li>Otorrinolaringología</li>
            <li>Pediatría</li>
            <li>Traumatología</li>
            <li>Urología</li>
          </ul>
          <p>
            <strong className={styles.swiss_medical_zamora__redText}>
              Diagnóstico por imágenes
            </strong>
          </p>
          <ul>
            <li>Ecografía general</li>
            <li>Resonancia magnética</li>
            <li>Radiología simple</li>
            <li>Radiología odontológica + panorámica</li>
            <li>Tomografía</li>
          </ul>
        </div>
        <div>
          <p>
            <strong className={styles.swiss_medical_zamora__redText}>Espacio mujer</strong>
          </p>
          <ul>
            <li>Densitometría</li>
            <li>Ecografía mamaria</li>
            <li>Ginecología</li>
            <li>Mamografía</li>
          </ul>
          <p>
            <strong className={styles.swiss_medical_zamora__redText}>Consultorios de ART</strong>
          </p>
          <ul>
            <li>Kinesiología</li>
            <li>Medicina laboral</li>
            <li>Terapia ocupacional</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SwissMedicalZamora;
